import { eventHasRun } from '../../utils/eventTracker';

export const DDC_MAP_PIN = 'ddc.map.pin';

function pin(win, doc, { timeStamp }, infoClass) {
	let eventObject;

	if (
		!eventHasRun(DDC_MAP_PIN, {
			timeStamp
		})
	) {
		eventObject = {
			eventType: DDC_MAP_PIN,
			eventData: {
				element: doc.querySelector(infoClass)
			}
		};
	}

	return eventObject;
}

export default pin;
